<template>
    <div class="cta-section">
        <h2 class="cta-title fuente-posm">Sorprende a tus Clientes</h2>

        <button class="button-outline gray fuente-nova2 py-3 px-5 hover-boton_mod cta-main-btn" @click="showModal">
            Contáctanos Ahora
        </button>

        <button class="cta-link fuente-nova2" @click="showPricingModal({
            description: 'Fideliza clientes y genera relaciones duraderas',
            price: '$500 MXN'
        })">
            Planes y Precios
        </button>
    </div>
</template>

<script>
import { openContactModal, openPricingModal } from '@/utils/modalHelper'

export default {
    name: 'CallToActionRewardNew',
    methods: {
        showModal() {
            openContactModal();
        },
        showPricingModal(options) {
            openPricingModal(options);
        }
    },
}
</script>

<style lang="css" scoped>
.cta-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.cta-title {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    text-align: center;
    margin: 0;
}

.cta-link {
    background: transparent;
    border: none;
    color: var(--color-2);
    font-size: 18px;
    cursor: pointer;
    text-decoration: underline;
    transition: opacity 0.3s ease;
}

.cta-link:hover {
    opacity: 0.7;
}

.cta-main-btn {
    font-size: 22px !important;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .cta-title {
        font-size: 60px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .cta-section {
        justify-content: center;
        padding: 20px;
        gap: 60px;
    }

    .cta-title {
        font-size: 34px;
    }

    .cta-link {
        font-size: 16px;
    }
}
</style>
